import styled from 'styled-components';

/* eslint-disable import/prefer-default-export */
export const Figure = styled.svg.attrs({
  role: props => props.role,
  'aria-label': props => props.arialabel
})`
  max-width: 100%;
`;
